import { DigestRequest } from "../Types/DigestRequest";
import { debouncedMerge, MergedRequests } from "../../../../Engine/src/Helpers/AsyncUtils";
import { IterUtils } from "../../../IterableUtils";
import { reject } from "../../../TypingUtils";
import { IDigestApiClient } from "../IDigestApiClient";
import { PicklistResultV2 } from "../../../PicklistApiClient/Types/PicklistResultV2";

export function withDebouncedBatching(client: IDigestApiClient, debounceInterval: number): IDigestApiClient {
    return new DigestApiClientWithDebouncedBatching(client, debounceInterval);
}

export class DigestApiClientWithDebouncedBatching implements IDigestApiClient {
    private readonly getDigestDebounced: (request: DigestRequest) => Promise<PicklistResultV2>;

    public constructor(innerClient: IDigestApiClient, debounceInterval: number) {
        this.getDigestDebounced = debouncedMerge(
            async (requests: MergedRequests<DigestRequest, PicklistResultV2>) => {
                try {
                    for (const [_, request] of IterUtils.iterateEntries(requests)) {
                        const digestResponse = await innerClient.getDigest(request.arg);
                        request.resolve(
                            digestResponse ?? reject(`Request for gId:'${request.arg.gId} does not received'`)
                        );
                    }
                } catch (error) {
                    for (const request of requests) {
                        request.reject(error);
                    }
                }
            },
            debounceInterval,
            x => JSON.stringify(x)
        );
    }

    public getDigest(request: DigestRequest): Promise<PicklistResultV2> {
        return this.getDigestDebounced(request);
    }
}
